<template>
  <v-form ref="form" @submit.prevent="submit">
    <v-text-field v-model="email" :rules="[required]" label="Email" />
    <v-text-field v-model="name" :rules="[required]" label="Full Name" />
    <v-text-field
      v-model="ssn"
      :rules="[required]"
      label="Social Security Number"
      mask="social"
    />
    <v-text-field
      v-model="phone"
      :rules="[required]"
      label="Phone Number"
      mask="phone"
    />
    <v-menu
      ref="dateOfBirth"
      v-model="isMenuOpen"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="dateOfBirth"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
    >
      <v-text-field
        slot="activator"
        label="Date of Birth"
        :value="dateOfBirth | formatDate"
        readonly
        :rules="[required]"
      />
      <v-date-picker v-model="dateOfBirth" no-title scrollable>
        <v-spacer />
        <v-btn flat color="primary" @click="isMenuOpen = false">
          Cancel
        </v-btn>
        <v-btn
          flat
          color="primary"
          @click="$refs.dateOfBirth.save(dateOfBirth)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>

    <v-btn type="submit" :loading="isRunning">
      Create Owner
    </v-btn>
  </v-form>
</template>

<script>
import { functions } from 'firebase/app';
import 'firebase/functions';
import dayjs from 'dayjs';
import { pick } from 'lodash-es';
import { getUid } from '@/plugins/firebase';
import { required } from '@/util';

export default {
  name: 'AddOwner',
  filters: {
    formatDate: value => value && dayjs(value).format('MM/DD/YYYY'),
  },
  data: () => ({
    email: null,
    name: null,
    ssn: null,
    phone: null,
    dateOfBirth: null,
    isRunning: false,
    isMenuOpen: false,
  }),
  methods: {
    required,
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.isRunning = true;
      await functions().httpsCallable('createOwnerAccount')({
        ...pick(this, ['email', 'name', 'ssn', 'phone', 'dateOfBirth']),
        admin: getUid(),
      });
      this.isRunning = false;
      this.$router.push('owners');
    },
  },
};
</script>

<style></style>
